define('usuario-imoveis-favoritos-resource',['i18n-provider', 'app-route-provider', 'notify-service'], function() {
  var app = angular.module('usuario.imoveis.favoritos.resource', ['i18n.provider', 'app.route.provider', 'notify.service']);
  app.factory('UsuarioImoveisFavoritos', ['$q', '$http', '$location', '$state', 'i18n', 'appRoute', 'notify',
    function($q, $http, $location, $state, i18n, appRoute, notify, $multipart) {
      return {
        setAvaliacao:function(item, value){
          return $q(function (resolve, reject) {
            return $http.post(appRoute.linkTo('usuarioImoveisFavoritos.setAvaliacao'), {item:item, value:value}).success(function (data) {
              resolve(data);
            }).error(function (error) {
              reject(error);
            });
          });
        },
        enviarContact:function(data){
          return $q(function (resolve, reject) {
            return $http.post(appRoute.linkTo('contato.enviarContact'), data).success(function (data) {
              resolve(data);
            }).error(function (error) {
              reject(error);
            });
          });
        },
        getLogs:function(data){
          return $q(function (resolve, reject) {
            return $http.post(appRoute.linkTo('usuarioImoveisFavoritos.getLogs'), data).success(function (data) {
              resolve(data);
            }).error(function (error) {
              reject(error);
            });
          });
        },
        getImoveisFavoritos:function(data){
          return $q(function (resolve, reject) {
            return $http.post(appRoute.linkTo('usuarioImoveisFavoritos.getImoveisFavoritos'), data).success(function (data) {
              resolve(data);
            }).error(function (error) {
              reject(error);
            });
          });
        }
      }
    }]);
});
